export default function createAddSelectablePropertyMapping(resolvedMappings) {
	return function (consumerDetail, resolvedValue) {
		const {consumerId, consumerPropName} = consumerDetail;
		if (!resolvedMappings.has(consumerId)) resolvedMappings.set(consumerId, new Map());
		resolvedMappings.get(consumerId).set(consumerPropName, resolvedValue);
	};
}
